module.exports = __webpack_public_path__ + "static/prozessbild-f086d5c6990d489f64085b3e10f26493.png";